// lavanda-preview — w24 "Lavanda" wedding preview card.
//
// Dreamy lavender field. The outer frame is a misted lavender wash; the
// inner card holds a lavender-sprig medallion, the couple's names in Pinyon
// Script, and a "TO'Y MAROSIMI" caption.
import { Photo, type LayoutCtx } from "./_shared";

export function LavandaPreviewLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${accent}33 0%, ${bg} 40%, ${accent}26 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}66`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TO'Y MAROSIMI
        </div>

        {/* Lavender sprig medallion */}
        <div style={{ width: "62%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <Photo
            src={photo}
            style={{ position: "absolute", inset: "10%", borderRadius: "50%" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}>
                <defs>
                  <radialGradient id="lavMist" cx="50%" cy="50%">
                    <stop offset="0%" stopColor={bg} />
                    <stop offset="100%" stopColor={`${accent}22`} />
                  </radialGradient>
                </defs>
                <circle cx="50" cy="50" r="44" fill="url(#lavMist)" stroke={accent} strokeWidth="0.5" opacity="0.7" />
                {/* Three lavender stalks */}
                {[-22, 0, 22].map((tilt, i) => (
                  <g key={i} transform={`translate(50 86) rotate(${tilt})`}>
                    <line x1="0" y1="0" x2="0" y2="-50" stroke={accent} strokeWidth="0.7" opacity="0.85" />
                    {Array.from({ length: 10 }).map((_, k) => {
                      const y = -16 - k * 3.4;
                      const side = k % 2 === 0 ? -1 : 1;
                      return (
                        <ellipse
                          key={k}
                          cx={side * 1.6}
                          cy={y}
                          rx="1.6"
                          ry="2.2"
                          fill={accent}
                          opacity={0.75 - k * 0.04}
                          transform={`rotate(${side * 18} ${side * 1.6} ${y})`}
                        />
                      );
                    })}
                  </g>
                ))}
                {/* Tie ribbon */}
                <rect x="44" y="78" width="12" height="3" fill={`${ink}88`} opacity="0.7" rx="0.6" />
              </svg>
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TO'Y MAROSIMI · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
